{
	"type": "fill",
	"minzoom": 8,
	"layout": {},
	"paint": {
		"fill-color": [
			"match",
			["get", "sll_desc"],
			"Primary",
			"#ed5151",
			"Secondary",
			"#149ece",
			"Combined",
			"#a7c636",
			"Ungraded",
			"#fc921f",
			"TAFE",
			"#9e559c",
			"Infant",
			"#f789d8",
			"#ffde3e"
		],
		"fill-antialias": true,
		"fill-outline-color": "#8B8B8B"
	}
}
